(function() {
  const INTERNATIONAL_MARKETS = ['US', 'ES', 'MX'];
  const CONVERSION_RATE = 1680;
  
  function getMarket() {
    if (window.Shopify && window.Shopify.market) {
      return window.Shopify.market.countryCode;
    }
    return null;
  }
  
  function convertPrice(priceText) {
    const match = priceText.match(/[\d.,]+/);
    if (!match) return null;
    const copPrice = parseFloat(match[0].replace(/\./g, '').replace(',', '.'));
    if (isNaN(copPrice)) return null;
    return 'USD $' + (copPrice / CONVERSION_RATE).toFixed(2);
  }
  
  function convertPricesOnPage() {
    const market = getMarket();
    if (!market || !INTERNATIONAL_MARKETS.includes(market)) return;
    
    const selectors = ['.price-item--regular', '.price-item--sale', '.price__regular .price-item', '.price__sale .price-item'];
    
    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        if (el.dataset.converted) return;
        const converted = convertPrice(el.textContent.trim());
        if (converted) {
          el.dataset.converted = 'true';
          el.innerHTML = converted + '<br><small style="font-size:0.7em;color:#666;font-weight:normal">* Cobro en COP al pagar</small>';
        }
      });
    });
  }
  
  document.addEventListener('DOMContentLoaded', convertPricesOnPage);
  new MutationObserver(convertPricesOnPage).observe(document.body, {childList: true, subtree: true});
})();
